var dropZone = 'fx_2d2fb1e5_bvuf5q0';

export { dropZone };
//# sourceMappingURL=drop-zone.vanilla.mjs.map
